import { heroEye, heroEyeSlash, heroLockClosed, heroXMark } from "@ng-icons/heroicons/outline";

export const initIcon = { heroXMark, heroLockClosed, heroEyeSlash, heroEye };